import { Instagram, Send, Youtube } from "lucide-react";

import { BLOG_CATEGORIES } from "@/lib/content/categories";

const BODY = { fontFamily: "var(--font-body)" };

const SOCIAL_LINKS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/ratieducacao",
    icon: Instagram,
  },
  {
    label: "Telegram",
    href: "https://t.me/ratieducacao",
    icon: Send,
  },
  {
    label: "YouTube",
    href: "https://youtube.com/@ratieducacao",
    icon: Youtube,
  },
];

const FALLBACK_FEATURED_ARTICLES = [
  {
    label: "Clitóris, anatomia e estimulação",
    href: "https://rati.com.br/clitoris-como-estimular-orgasmo/",
  },
  {
    label: "BDSM, um guia para iniciantes",
    href: "https://rati.com.br/bdsm-guia-completo/",
  },
  {
    label: "Como transar melhor",
    href: "https://rati.com.br/como-transar/",
  },
  {
    label: "Vulva ou Vagina? Entenda a diferença",
    href: "https://rati.com.br/vulva-vs-vagina-diferenca/",
  },
];

type FooterFeaturedPost = {
  title?: string;
  url?: string;
};

interface SiteFooterProps {
  featuredPosts?: FooterFeaturedPost[];
}

export function SiteFooter({ featuredPosts }: SiteFooterProps) {
  const resolvedFeatured =
    featuredPosts && featuredPosts.length > 0
      ? featuredPosts
          .filter((post): post is { title: string; url: string } => Boolean(post.title) && Boolean(post.url))
          .map((post) => ({ label: post.title, href: post.url }))
      : FALLBACK_FEATURED_ARTICLES;

  return (
    <footer className="relative border-t border-white/10 px-8 py-16">
      <div className="max-w-7xl mx-auto grid gap-12 md:grid-cols-[1.3fr_1fr_1fr]">
        <div className="max-w-md">
          <img
            src="https://rati.com.br/wp-content/uploads/2020/12/logo-small.png"
            alt="RATI"
            className="h-9 object-contain mb-7"
          />
          <p className="text-white/58 text-lg leading-[1.75] max-w-sm" style={BODY}>
            Educação sexual de verdade — sem julgamento, sem eufemismo, sem teoria de livro.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            {SOCIAL_LINKS.map(({ label, href, icon: Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="inline-flex items-center justify-center rounded-2xl border border-white/15 p-3 text-white/75 transition-colors hover:border-pink-500/35 hover:text-white"
                style={BODY}
              >
                <Icon size={22} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-6 text-sm font-bold uppercase tracking-[0.16em] text-white/45" style={BODY}>
            Categorias
          </h3>
          <div className="space-y-4">
            {BLOG_CATEGORIES.map((category) => (
              <a
                key={category.slug}
                href={`/blog/categoria/${category.slug}/`}
                className="block text-[1.08rem] leading-relaxed text-white/80 transition-colors hover:text-white"
                style={BODY}
              >
                {category.name}
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-6 text-sm font-bold uppercase tracking-[0.16em] text-white/45" style={BODY}>
            Artigos em destaque
          </h3>
          <div className="space-y-4">
            {resolvedFeatured.map((article) => (
              <a
                key={article.href}
                href={article.href}
                className="block text-[1.08rem] leading-relaxed text-white/80 transition-colors hover:text-white"
                style={BODY}
              >
                {article.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
